export const SET_PROFILES = 'SET_PROFILES';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const DELETE_PROFILE = 'DELETE_PROFILE'; 